import Event from '../../core/Event';
import UserEstimationDetails from 'src/domain/SummaryData';

export default class UserEstimationGetSucceed extends Event {
    public static type = 'UserEstimationGetSucceed';

    constructor(public readonly estimation: UserEstimationDetails) {
        super(UserEstimationGetSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/UserEstimationGetSucceed.ts